// Custom API error classes
export class ApiError extends Error {
  public status: number;
  public responseData?: unknown;
  public url?: string;
  public method?: string;
  public timestamp: string;
  private readonly _userMessage?: string;

  constructor(
    message: string,
    status: number,
    responseData?: unknown,
    url?: string,
    method?: string,
  ) {
    // Create a more detailed error message that includes context
    const contextMessage =
      url && method
        ? `${method} ${url}: ${message} (Status: ${status})`
        : `${message} (Status: ${status})`;

    super(contextMessage);
    this.name = "ApiError";
    this._userMessage = message; // Store the original message for user display
    this.status = status;
    this.responseData = responseData;
    this.url = url;
    this.method = method;
    this.timestamp = new Date().toISOString();
  }

  public get userMessage(): string {
    return this._userMessage ?? this.message;
  }
}

export class UnauthorizedError extends ApiError {
  constructor(
    message: string,
    responseData?: unknown,
    url?: string,
    method?: string,
  ) {
    super(message, 401, responseData, url, method);
    this.name = "UnauthorizedError";
  }
}

export class ForbiddenError extends ApiError {
  constructor(
    message: string,
    responseData?: unknown,
    url?: string,
    method?: string,
  ) {
    super(message, 403, responseData, url, method);
    this.name = "ForbiddenError";
  }
}

export class NotFoundError extends ApiError {
  constructor(
    message: string,
    responseData?: unknown,
    url?: string,
    method?: string,
  ) {
    super(message, 404, responseData, url, method);
    this.name = "NotFoundError";
  }
}

export class ServerError extends ApiError {
  constructor(
    message: string,
    responseData?: unknown,
    url?: string,
    method?: string,
  ) {
    super(message, 500, responseData, url, method);
    this.name = "ServerError";
  }
}
